.wrap {
  position: relative;
  display: inline-block;
}

.menu {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  z-index: 60;
  min-width: 190px;
  padding: 6px;
  background: var(--vc-surface);
  border: 1px solid var(--vc-border);
  border-radius: var(--vc-radius-md);
  box-shadow: var(--vc-shadow-lg);
  animation: pop 140ms var(--vc-ease);

  &.left {
    right: auto;
    left: 0;
  }

  // Opens above the trigger (bottom-of-screen triggers such as the sidebar user card).
  &.top {
    top: auto;
    bottom: calc(100% + 6px);
    animation-name: popUp;
  }

  .item {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 10px;
    border-radius: var(--vc-radius-sm);
    font-size: var(--vc-text-md);
    color: var(--vc-text);
    text-align: left;
    text-decoration: none;

    &:hover,
    &:focus-visible {
      background: var(--vc-gray-soft);
      text-decoration: none;
      box-shadow: none;
    }

    &:disabled {
      opacity: 0.5;
    }

    svg {
      width: 15px;
      height: 15px;
      color: var(--vc-text-muted);
    }

    &.danger {
      color: var(--vc-red);

      svg {
        color: var(--vc-red);
      }
    }
  }

  .divider {
    height: 1px;
    margin: 6px 4px;
    background: var(--vc-border);
  }

  .label {
    padding: 6px 10px 4px;
    font-size: var(--vc-text-xs);
    font-weight: var(--vc-weight-semibold);
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: var(--vc-text-muted);
  }
}

@keyframes pop {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
}

@keyframes popUp {
  from {
    opacity: 0;
    transform: translateY(4px);
  }
}

/* Tooltip */
.tooltipWrap {
  position: relative;
  display: inline-flex;

  .tooltip {
    position: absolute;
    bottom: calc(100% + 6px);
    left: 50%;
    transform: translateX(-50%);
    z-index: 70;
    padding: 6px 9px;
    border-radius: var(--vc-radius-sm);
    background: var(--vc-text);
    color: #fff;
    font-size: var(--vc-text-xs);
    font-weight: var(--vc-weight-medium);
    white-space: nowrap;
    pointer-events: none;
    opacity: 0;
    transition: opacity var(--vc-duration) var(--vc-ease);
  }

  &:hover .tooltip,
  &:focus-within .tooltip {
    opacity: 1;
  }
}
